<p-sidebar
  position="left"
  [autoZIndex]="false"
  [visible]="(isMenuVisible$ | async) === false && !isWindowOpen"
  [showCloseIcon]="false"
  [modal]="false"
  styleClass="ice-pop-layout-sidebar mobile"
>
  <div class="m-menu-container">
    <div class="m-menu-main-container">
      <div class="m-menu-header">
        <div>
          <a
            href="javascript: void(0)"
            class="m-menu-back-button"
            (click)="toggleSideMenu()"
          >
            <img src="./assets/images/ic-back-m.svg" />
          </a>
          <p-avatar
            image="./assets/images/sample-avatar.png"
            shape="circle"
          ></p-avatar>
          <span class="ml-15">{{ userNoAndName }}</span>
        </div>
        <button
          pButton
          pRipple
          type="button"
          label="Log Out"
          class="p-button-rounded p-button-outlined m-menu-button"
          (click)="logout()"
        ></button>
      </div>
      <ul class="m-menu-list">
        <p-accordion [collapseIcon]="'pi pi-angle-up'" [expandIcon]="'pi fw pi-chevron-down'" styleClass="menu-accordion">
          <p-accordionTab>
            <ng-template pTemplate="header">{{ this.locale | optionsMapping : languageOptions }}</ng-template>
            <ng-template pTemplate="content">
              <ul class="m-menu-list">
                <li *ngFor="
                  let language of languageOptions;
                  let languageIndex = index
                " class="m-menu-list-item p-p-0">
                  <a href="javascript: void(0)" class="m-menu-sub-list-link" (click)="changeLanguage($event, language)">
                    {{ language.label }}
                  </a>
                </li>
              </ul>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
        <li class="m-menu-list-item">
          <a
            href="#"
            class="m-menu-list-link has-sub"
            (click)="openSubMenu('changePassword')"
          >
            {{ "Login.ChangePassword" | translate }}
          </a>

          <div
            class="m-menu-sub-container"
            [ngClass]="{ active: currentSubMenu === 'changePassword' }"
          >
            <div class="m-menu-sub-title">
              <div>
                <a href="#" class="m-menu-back-button" (click)="closeSubMenu()">
                  <img src="./assets/images/ic-back-m.svg" />
                </a>
                {{ "Login.ChangePassword" | translate }}
              </div>
            </div>
            <!-- change password form -->
            <form class="change-password-form" #changePasswordForm="ngForm">
              <div class="change-password-form-inner-container">
                <div class="p-fluid">
                  <div class="p-field mt-0">
                    <label>{{
                      "ForgotPassword.CurrentPassword" | translate
                    }}</label>
                    <input
                      type="password"
                      name="newPassword"
                      pInputText
                      [placeholder]="
                        'ForgotPassword.CurrentPassword' | translate
                      "
                      [(ngModel)]="currentPassword"
                      required
                      required
                      #currentPasswordDom="ngModel"
                    />
                    <small
                      class="p-error"
                      *ngIf="
                        currentPasswordDom.invalid &&
                        (currentPasswordDom.dirty ||
                          currentPasswordDom.touched) &&
                        currentPasswordDom.errors?.required
                      "
                    >
                      {{
                        "Common.Validate.Required"
                          | translate
                            : {
                                fieldName:
                                  "ForgotPassword.CurrentPassword" | translate
                              }
                      }}
                    </small>
                  </div>
                  <div class="p-field">
                    <label>{{
                      "ForgotPassword.NewPassword" | translate
                    }}</label>
                    <input
                      type="password"
                      name="newPassword"
                      pInputText
                      [placeholder]="'ForgotPassword.NewPassword' | translate"
                      required
                      minlength="8"
                      maxlength="256"
                      [(ngModel)]="newPassword"
                      appPasswordComplexity
                      #newPasswordDom="ngModel"
                    />
                    <ng-container
                      *ngIf="
                        newPasswordDom.invalid &&
                        (newPasswordDom.dirty || newPasswordDom.touched)
                      "
                    >
                      <small
                        class="p-error"
                        *ngIf="newPasswordDom.errors?.required"
                      >
                        {{
                          "Common.Validate.Required"
                            | translate
                              : {
                                  fieldName:
                                    "ForgotPassword.NewPassword" | translate
                                }
                        }}
                      </small>
                      <small
                        class="p-error"
                        *ngIf="newPasswordDom.errors?.passwordComplixity"
                      >
                        {{
                          "Common.Validate.PasswordStrengNotification"
                            | translate
                        }}
                      </small>
                    </ng-container>
                  </div>
                  <div class="p-field">
                    <label>{{
                      "ForgotPassword.ConfirmNewPassword" | translate
                    }}</label>
                    <input
                      type="password"
                      name="confirmNewPassword"
                      [placeholder]="
                        'ForgotPassword.ConfirmNewPassword' | translate
                      "
                      pInputText
                      [(ngModel)]="confirmPassword"
                      required
                      [appEqualTo]="newPassword"
                      #confirmPasswordDom="ngModel"
                    />
                    <small
                      class="p-error"
                      *ngIf="
                        confirmPasswordDom.invalid &&
                        (confirmPasswordDom.dirty ||
                          confirmPasswordDom.touched) &&
                        confirmPasswordDom.errors?.required
                      "
                    >
                      {{
                        "Common.Validate.Required"
                          | translate
                            : {
                                fieldName:
                                  "ForgotPassword.ConfirmNewPassword"
                                  | translate
                              }
                      }}
                    </small>
                    <small
                      class="p-error"
                      *ngIf="
                        confirmPasswordDom.invalid &&
                        (confirmPasswordDom.dirty ||
                          confirmPasswordDom.touched) &&
                        confirmPasswordDom.errors?.equalTo
                      "
                    >
                      {{
                        "Common.Validate.ConfirmPasswordNotEqualToPassword"
                          | translate
                      }}
                    </small>
                  </div>
                  <div *ngIf="elementControlJSON.Login.GoogleReCaptcha.display" class="p-field">
                    <re-captcha
                      name="captcha"
                      class="p-d-flex p-jc-center"
                      (error)="errored($event)"
                      errorMode="handled"
                      [(ngModel)]="recaptchaToken"
                      required
                      [siteKey]="appConfig.recaptchaSiteKey"
                    ></re-captcha>
                  </div>
                </div>
              </div>
              <div class="p-grid">
                <div class="p-col-6">
                  <div class="button pv-0 ph-0">
                    <a
                      role="button"
                      href="javascript: void(0)"
                      class="btn btn-secondary"
                      (click)="clearChangePasswordForm()"
                      >{{ "Common.Button.Clear" | translate }}</a
                    >
                  </div>
                </div>
                <div class="p-col-6">
                  <div class="button pv-0 ph-0">
                    <a
                      href="javascript: void(0)"
                      class="btn btn-primary"
                      (click)="submitChangePassword(changePasswordForm)"
                      >{{ "Common.Button.Submit" | translate }}</a
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
        </li>
        <li
          class="m-menu-list-item"
          *ngFor="let menuItem of hasPermissionMenus; let menuIndex = index"
        >
          <a
            href="javascript: void(0)"
            class="m-menu-list-link"
            (click)="menuItemAction(menuItem)"
          >
            <img
              [src]="'./assets/images/' + menuItem.icon"
              [ngClass]="{
                'm-menu-icon-highlight': menuItem.isHighlight === true
              }"
            />
            {{ menuItem.translateKey | translate }}
            <div
              *ngIf="menuItem.eventCount"
              [ngClass]="[
                'badge',
                getBadgeStatusClassName(menuItem.eventCount)
              ]"
            >
              {{ menuItem.eventCount }}
            </div>
          </a>
          <div
            class="m-menu-sub-container"
            *ngIf="menuItem.subMenus && menuItem.subMenus!.length > 0"
            [ngClass]="{ active: currentSubMenu === menuItem.label }"
          >
            <div class="m-menu-sub-title">
              <div>
                <a
                  href="javascript: void(0)"
                  class="m-menu-back-button"
                  (click)="closeSubMenu()"
                >
                  <img src="./assets/images/ic-back-m.svg" />
                </a>
                {{ menuItem.translateKey | translate }}
              </div>
            </div>
            <ul class="m-menu-sub-list">
              <li
                class="m-menu-sub-item"
                *ngFor="
                  let subMenu of menuItem.subMenus;
                  let subMenuIndex = index
                "
              >
                <a
                  href="javascript: void(0)"
                  class="m-menu-sub-list-link"
                  (click)="goToPageAndCloseMenu(subMenu.routerLinkPath)"
                >
                  <img
                    [src]="'./assets/images/' + subMenu.icon"
                    width="24"
                    height="24"
                  />
                  {{ subMenu.translateKey | translate }}
                  <div
                    *ngIf="subMenu.eventCount"
                    [ngClass]="[
                      'badge',
                      getBadgeStatusClassName(subMenu.eventCount)
                    ]"
                  >
                    {{ subMenu.eventCount }}
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</p-sidebar>

<p-sidebar
  position="left"
  [autoZIndex]="false"
  [visible]="(isMenuVisible$ | async) === true"
  [showCloseIcon]="false"
  [modal]="false"
  styleClass="ice-pop-layout-sidebar desktop"
>
  <div class="ice-pop-container">
    <ul class="ice-pop-item-list">
      <li
        *ngFor="let menuItem of hasPermissionMenus; let menuIndex = index"
        class="ice-pop-item p-d-flex p-flex-column p-align-center p-jc-center"
        [ngClass]="{
          'ice-pop-todo':
            menuItem.label === 'Todo' ||
            menuItem.label === 'Case Management' ||
            menuItem.label === 'Announcement Setting' ||
            menuItem.label === 'Report',
          'multi-layer': menuItem.subMenus && menuItem.subMenus!.length > 0,
          'insurance-pop': menuItem.label === 'Insurance'
        }"
      >
        <a
          href="javascript: void(0)"
          (click)="goToPage(menuItem.routerLinkPath)"
          *ngIf="menuItem.routerLinkPath; else withoutLink"
        >
          <div
            class="ice-pop-logo"
            [ngClass]="{ 'ice-pop-highlight': menuItem.isHighlight === true }"
          >
            <img [src]="'./assets/images/' + menuItem.icon" />
            <div class="ice-pop-unread" *ngIf="menuItem.eventCount">
              {{ menuItem.eventCount }}
            </div>
          </div>
        </a>
        <ng-template #withoutLink>
          <div
            class="ice-pop-logo"
            [ngClass]="{ 'ice-pop-highlight': menuItem.isHighlight === true }"
          >
            <img [src]="'./assets/images/' + menuItem.icon" />
            <div class="ice-pop-unread" *ngIf="menuItem.eventCount">
              {{ menuItem.eventCount }}
            </div>
          </div>
        </ng-template>
        <div class="ice-pop-title">{{ menuItem.translateKey | translate }}</div>

        <div
          *ngIf="menuItem.subMenus && menuItem.subMenus!.length > 0"
          class="ice-pop-layer2-tab p-d-flex p-flex-row p-jc-end p-ai-start"
        >
          <ul class="ice-pop-layer2-list p-d-flex p-flex-column">
            <ng-template ngFor let-subMenu [ngForOf]="menuItem.subMenus">
              <li
                *ngIf="
                  (subMenu.onlyUseRole !== undefined &&
                    subMenu.onlyUseRole === useRole) ||
                  subMenu.onlyUseRole === undefined
                "
                (click)="goToPage(subMenu.routerLinkPath)"
                class="ice-pop-layer2-item p-d-flex p-flex-row p-ai-center p-jc-start"
              >
                <img
                  [src]="'./assets/images/' + subMenu.icon"
                  width="24"
                  height="24"
                />
                <span>{{ subMenu.translateKey | translate }}</span>
                <div *ngIf="subMenu.eventCount">
                  {{ subMenu.eventCount }}
                </div>
              </li>
            </ng-template>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</p-sidebar>
